import * as React from "react";
import '../theme/_cover-checker-page.scss';


export default class Header extends React.Component<{}, {}> {

    public render() {
        return (
            <div className="cover-checker-header">
                <div className="cover-checker-header-text">
                    <h1>VOLKSWAGEN FINANCIAL SERVICES</h1>
                </div>
            </div>
        )
    }
}
